export default function Testimonials() {
  const testimonials = [
    {
      name: "María González",
      location: "Chamberí, Madrid",
      rating: 5,
      text: "Profesionales excepcionales. Reformaron completamente nuestro piso y el resultado superó nuestras expectativas. Cumplieron plazos y presupuesto sin sorpresas.",
      image: "https://public.readdy.ai/ai/img_res/946078687746be5cb1ba40d84e8970a8.jpg"
    },
    {
      name: "Carlos Ruiz",
      location: "Salamanca, Madrid",
      rating: 5,
      text: "Hicieron la reforma integral de mi oficina. Trabajo impecable, muy atentos a cada detalle. La comunicación fue excelente durante todo el proceso.",
      image: "https://readdy.ai/api/search-image?query=Professional%20businessman%20in%20his%20forties%20standing%20in%20modern%20renovated%20office%20space%2C%20satisfied%20client%20portrait%2C%20confident%20smile%2C%20business%20casual%20attire&width=400&height=400&seq=testimonial-carlos&orientation=squarish"
    },
    {
      name: "Laura Martínez",
      location: "Retiro, Madrid",
      rating: 5,
      text: "Reformaron dos baños y la cocina de mi casa. Quedé encantada con el resultado. Son rápidos, limpios y muy profesionales. Totalmente recomendables.",
      image: "https://readdy.ai/api/search-image?query=Young%20professional%20woman%20homeowner%20in%20her%20thirties%20standing%20in%20beautiful%20renovated%20bathroom%2C%20happy%20satisfied%20expression%2C%20modern%20interior%20design%20background&width=400&height=400&seq=testimonial-laura&orientation=squarish"
    },
    {
      name: "Javier Sánchez",
      location: "Arganzuela, Madrid",
      rating: 5,
      text: "Necesitaba una reforma urgente y cumplieron con los plazos acordados. Muy serios y responsables. El equipo dejó todo impecable cada día.",
      image: "https://readdy.ai/api/search-image?query=Satisfied%20male%20homeowner%20in%20his%20fifties%20standing%20in%20renovated%20living%20room%2C%20genuine%20smile%2C%20casual%20clothing%2C%20modern%20home%20interior%20with%20natural%20light&width=400&height=400&seq=testimonial-javier&orientation=squarish"
    },
    {
      name: "Ana Fernández",
      location: "Moncloa, Madrid",
      rating: 5,
      text: "Reformaron mi local comercial y el trabajo fue excelente. Muy profesionales, atentos y con precios justos. Sin duda volveré a contar con ellos.",
      image: "https://readdy.ai/api/search-image?query=Professional%20businesswoman%20standing%20in%20renovated%20commercial%20space%2C%20satisfied%20client%20portrait%2C%20confident%20and%20happy%20expression%2C%20modern%20shop%20interior%20background&width=400&height=400&seq=testimonial-ana&orientation=squarish"
    },
    {
      name: "Roberto Díaz",
      location: "Carabanchel, Madrid",
      rating: 5,
      text: "Hicieron la instalación eléctrica completa de mi vivienda. Trabajo de calidad, cumplieron tiempos y el precio fue muy competitivo. Muy recomendables.",
      image: "https://readdy.ai/api/search-image?query=Middle%20aged%20man%20homeowner%20standing%20in%20well%20lit%20renovated%20home%2C%20satisfied%20customer%20portrait%2C%20friendly%20smile%2C%20modern%20residential%20interior%20with%20good%20lighting&width=400&height=400&seq=testimonial-roberto&orientation=squarish"
    }
  ];

  return (
    <section className="py-24 px-6 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Lo Que Dicen Nuestros Clientes
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            La satisfacción de nuestros clientes en Madrid es nuestra mejor carta de presentación
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-lg transition-shadow"
            >
              <div className="flex items-center mb-6">
                <div className="w-16 h-16 flex items-center justify-center rounded-full overflow-hidden mr-4">
                  <img 
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-900">{testimonial.name}</h3>
                  <p className="text-sm text-gray-500">{testimonial.location}</p>
                </div>
              </div>

              <div className="flex mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-amber-400 text-lg"></i>
                ))}
              </div>

              <p className="text-gray-700 leading-relaxed">
                "{testimonial.text}"
              </p>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <a 
            href="#contacto"
            className="inline-flex items-center justify-center px-8 py-4 bg-rose-400 text-gray-900 text-base font-medium rounded-full hover:bg-rose-300 transition-colors whitespace-nowrap cursor-pointer"
          >
            Solicitar Presupuesto Gratis
          </a>
        </div>
      </div>
    </section>
  );
}